import { render, staticRenderFns } from "./StatisticsIndex.vue?vue&type=template&id=6bde81fd"
import script from "./StatisticsIndex.vue?vue&type=script&lang=js"
export * from "./StatisticsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports